/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GenericResponse } from '../models/generic-response';
import { LoginApiResponse } from '../models/login-api-response';
import { LoginRequest } from '../models/login-request';

/**
 * Open Authentication/credential related Apis
 */
@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `passwordLogin()` */
  static readonly PasswordLoginPath = '/api/v1/auth/login';

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `passwordLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  passwordLogin$Response(
    params: {
      body: LoginRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<LoginApiResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      AuthService.PasswordLoginPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LoginApiResponse>;
        })
      );
  }

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `passwordLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  passwordLogin(
    params: {
      body: LoginRequest;
    },
    context?: HttpContext
  ): Observable<LoginApiResponse> {
    return this.passwordLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginApiResponse>): LoginApiResponse => r.body)
    );
  }

  /** Path part for operation `userLogout()` */
  static readonly UserLogoutPath = '/api/v1/auth/logout';

  /**
   * Record user login and logout times.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  userLogout$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      AuthService.UserLogoutPath,
      'post'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Record user login and logout times.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userLogout(params?: {}, context?: HttpContext): Observable<GenericResponse> {
    return this.userLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `refreshToken()` */
  static readonly RefreshTokenPath = '/api/v1/auth/refresh-token';

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<LoginApiResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      AuthService.RefreshTokenPath,
      'post'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LoginApiResponse>;
        })
      );
  }

  /**
   * Refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken(
    params?: {},
    context?: HttpContext
  ): Observable<LoginApiResponse> {
    return this.refreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginApiResponse>): LoginApiResponse => r.body)
    );
  }
}
